import { visitSummaryNotes } from "@api/reports/visitSummaryNotes/path";
import { transactions } from "@api/reports/transactions/path";
import { referral } from "@api/reports/referral/path";
import { prescription } from "@api/reports/prescription/path";
import { noShowAppointment } from "@api/reports/noShowAppointments/path";
import { hospitalIncome } from "@api/reports/hospitalIcome/path";
import { followUp } from "@api/reports/followUp/path";
import { doctorVisitCost } from "@api/reports/doctorVisitCost/path";
import { doctorIncome } from "@api/reports/doctorsIncome/path";
import { appointments } from "@api/reports/appointments/path";
import { allPatients } from "@api/reports/allPatients/path";
import { images } from "@api/reports/images/path";
import { experiments } from "@api/reports/experiments/path";
import { orders } from "@api/reports/orders/path";
import { medicalHistory } from "@api/reports/medicalHistory/path";
import { medicalServiceProvider } from "@api/reports/medicalServiceProvider/path";
import { medicalServiceCenters } from "@api/reports/medicalServiceCenters/path";
import { medicalServiceProviderDoctors } from "@api/reports/medicalServiceProviderDoctors/path";
import { medicalServiceAssign } from "@api/reports/medicalServiceAssignList/path";
import { medicalServiceServices } from "@api/reports/medicalServiceServices/path";
import { systemAccounting } from "@api/reports/systemAccounting/path";

export const reports = {
  orders,
  experiments,
  images,
  allPatients,
  appointments,
  doctorIncome,
  doctorVisitCost,
  followUp,
  hospitalIncome,
  noShowAppointment,
  prescription,
  referral,
  transactions,
  visitSummaryNotes,
  medicalHistory,
  medicalServiceProvider,
  medicalServiceCenters,
  medicalServiceProviderDoctors,
  medicalServiceAssign,
  medicalServiceServices,
  systemAccounting,
};
